export default function displaySalesHistory(results) {
    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
  
    let s = `
    <h3>Sale History</h3>
 `
    if (results.length)
        {
            s += `<table class="summaryTable table-responsive ">    
            <thead>
                <th>Date of Sale</th>        <th>Sale Type</th> <th>Gross Selling Price</th><th>Sale Type</th>
            </thead>`;
        
            for (let i = 0, il = results.length; i < il; i++) {
                let date = new Date(results[i].date_of_sale);
                s+=`<tr>
                        <td>${date.toLocaleDateString('en-us', { year:"numeric", month:"numeric", day:"numeric"}) }</td> <td>${results[i].document_number}</td><td>${USDollar.format(results[i].gross_selling_price)}</td><td>${results[i].sale_type}</td>
                    </tr>`
            }
            s += "</table>";

        }
        else {
            s+= `<p>No sale history data to display.</p>`
        }
    return s; 
}